<template>
	<el-dialog :visible.sync="showcargosort" :title="title" width="400px" :append-to-body="true"  :close-on-click-modal="false">
		<div class="inputBox">
			<el-form  label-width="80px" size="mini">
				<el-form-item label="上级分类" v-if="sortinfo.parentsort!=''">
				    <span>{{sortinfo.parentsort}}</span>
				</el-form-item>
				<el-form-item label="语言" v-if="sortinfo.id==''">
					<el-select v-model="sortinfo.lang" placeholder="" style="width:100%">
						<el-option :label="item.label" :value="item.value" v-for="(item, index) in langlist" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="分类编号">
				    <el-input v-model="sortinfo.p_no" ref="p_no"></el-input>
				</el-form-item>
				<el-form-item label="分类名称">
				    <el-input v-model="sortinfo.p_sort" ref="p_sort"></el-input>
				</el-form-item>
				<el-form-item label="分类图片">
					<div >
						<el-upload
							v-show="sortinfo.search_pic==''"
							name="fileupload"
							class="upload-demo"
							:auto-upload="false"
							:action="uploadurl"
							:file-list="fileList"
							:on-change="UploadChange"
							:on-error="UploadError"
							:on-success="UploadSuccess"
							:show-file-list="false"
							:limit="1"
							accept="image/*"
							ref="upload"
						>
							<el-button size="mini" type="primary">上传图片</el-button>
						</el-upload>
						<el-button type="danger" v-if="sortinfo.search_pic!=''" @click="delfile(0)">清除</el-button>
				  </div>
				  <div v-show="sortinfo.search_pic!=''" class="divimgpic">
					  <el-image  :src="sortinfo.search_pic" class="imgpic"></el-image>
				  </div>
				</el-form-item>
				<el-form-item label="是否启用">
				    <el-switch
				    	v-model="sortinfo.isenabled"
				    	:active-value="true"
				    	:inactive-value="false"
				    	active-color="#13ce66"
				    ></el-switch>
				</el-form-item>
			</el-form>
		</div>
		<span slot="footer" class="dialog-footer">
			<div style="text-align:center;width:100%;padding-top:10px">
				<el-button size="mini" type="primary" @click.native="savecargosort(false)">保存并继续</el-button>
				<el-button size="mini" type="success" @click.native="savecargosort(true)">保存</el-button>
				<el-button size="mini" style="margin-left:10px" type="info" plain @click.native="closewin">关闭</el-button>
			</div>
		</span>
	</el-dialog>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	props: {
	},
	data() {
		return {
			showcargosort:false,
			title:'',
			sortinfo:{
				parentsort:'',
				p_id:'0',
				p_sort:'',
				isenabled:true,
				id:'',//用于修改
				lang:'',
				search_pic:''
			},
			langlist:[],
			divclass:'inputBox',
			fileList:[],
			uploadurl:'',
			editid:'',
			cargotype:''
		};
	},
	methods:{
		init(param){
			this.sortinfo={
				parentsort:'',
				p_id:'0',
				p_p_no:'',
				p_sort:'',
				isenabled:true,
				id:'',
				lang:'',
				search_pic:'',
				p_no:''
			}
			this.fileList=[];
			this.uploadurl='';
			this.title='';
			this.cargotype='';
			this.showcargosort=true;
			if(param.title!=undefined)
				this.title=param.title;
			if(param.parentsort!=undefined)
				this.sortinfo.parentsort=param.parentsort;
			if(param.p_p_no!=undefined)
				this.sortinfo.p_p_no=param.p_p_no;
			if(param.id!=undefined)
				this.sortinfo.id=param.id;
			if(param.lang!=undefined)
				this.sortinfo.lang=param.lang;
			if(param.cargotype!=undefined)
				this.cargotype=param.cargotype;
			var that=this;
			this.$nextTick(function(){
				that.$refs.p_no.focus();
			});
			this.GetCargoSortInfo();
		},
		GetCargoSortInfo(){
			if(this.sortinfo.id==''){
				this.GetLanglist();
			}else{
				var that=this;
				var paraminfo={
					id: this.sortinfo.id,
					lang:this.sortinfo.lang,
					cargotype:this.cargotype
				}
				this.$apipost.get.GetCargoSortList({paraminfo:paraminfo}).then(res => {
					if (res.list != undefined) {
						if(res.list.length>0)
						{
							that.editid=that.sortinfo.id;
							that.sortinfo=res.list[0];
							that.GetLanglist();
						}
						else
							this.$tool.message('未查找到分类信息', 0);
					}
				});
			}
		},
		GetLanglist(){
			//debugger
			var that = this;
			this.$apipost.get.dic({ type: '语言类型' }).then(res => {
				//console.log('list',res.list);
				if (res.list != undefined) {
					that.langlist=res.list;
					if(that.sortinfo.lang=='')
						that.sortinfo.lang=res.list[0].value;
				}
			});
		},
		//移除上传的文件
		delfile(index) {
			this.$refs.upload.abort(this.fileList[index]);
			this.fileList.splice(index, 1);
			this.sortinfo.search_pic='';
		},
		UploadChange(file, fileList) {
			var that = this;
			if (fileList.length > 0) {
				var list = [];
				fileList.forEach(e => {
					const isLt20M = e.size / 1024 / 1024 < 20;
					if (!isLt20M) {
						this.$tool.message(e.name + '已超过20M,不允许上传', 0);
						this.$refs.upload.abort(e);
					} else {
						list = list.concat(e);
					}
				});
				that.fileList = list;
				that.getLocalImg(file);
			}
		},
		UploadError(err, file, fileList) {
			console.log('上传错误 error', err);
		},
		//上传成功
		UploadSuccess(res, file, fileList) {
			this.$tool.loadingclose();
			if (res.state == '1') {
				this.$tool.message('保存成功', 1);
				this.closewin();
			} else this.$tool.message(res.message, 0);
		},
		getLocalImg(file) {
			// 获取上传图片的本地url，用于上传前的本地预览
			var that=this;
			 let reader = new FileReader()
			  reader.readAsDataURL(file.raw)
			  reader.onload = () => {
			    that.sortinfo.search_pic = reader.result;
			  }
		},
		//保存分类
		savecargosort(isclose){
			var that=this;
			if(this.sortinfo.p_sort.replace(/ /g,'')=='')
			{
				this.$tool.message('请填写商品分类', 0);
				return false;
			}
			var paraminfo=JSON.parse(JSON.stringify(this.sortinfo));
			paraminfo.search_pic=undefined;
			paraminfo.cargotype=this.cargotype;
			paraminfo.userid=localStorage.getItem('userid');
			this.$tool.loading('正在设置', this.divclass);
			debugger
			this.$apipost.post.SaveCargoSort_SC({paraminfo:paraminfo}).then(res => {
				this.$tool.loadingclose();
				if(res.state=='1'){
					if(res.id!=''){
						if (that.fileList.length > 0) {
							if (that.fileList[0].status == 'ready') {
								that.uploadurl = that.$apiprototype.ApiServer + '/Base/UploadCargoPic?domain=' + that.$apiprototype.WebServer + '&id=' + res.id+'&cargotype='+that.cargotype+'&type=sort';
								this.$nextTick(function() {
									that.$refs.upload.submit();
								});
							}
						}else{
							if (that.editid != ''&&that.sortinfo.search_pic=='') {
								//清除商品图片
								this.$apipost.post.DelBaseCargoPic({id: that.editid,type:'sort',cargotype:that.cargotype }).then(delres => {
									//console.log('delres', delres);
								});
							}
							this.$tool.message('保存成功', 1);
							if(isclose||that.sortinfo.id!=''){
								setTimeout(function(){
									that.closewin();
								},1500);
							}else
								that.sortinfo.p_sort='';
						}
					}
				}else{
					this.$tool.message(res.message, 0);
				}
			});
		},
		closewin(){
			var that=this;
			this.showcargosort=false;
			if(that.sortinfo.p_p_no=='0')
				that.$parent.getTablelist('0');
			else
				that.$parent.reloadpage();
		}
	}
}
</script>

<style>
.divimgpic{
	text-align:center; 
	max-width:120px;
	max-height:120px;
	padding:5px;
	border:1px solid #dfdfdf;
	border-radius:5px;
	margin-top:10px;
	margin-bottom:10px;
}
.imgpic{
	max-width:110px;
	max-height:110px;
}
</style>
